import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  currencyRow: {
    paddingBottom: '24px',
    marginBottom: '30px',
    borderBottom: '1px solid #e2ebf6',
    

  },
  dailyCurrencyRow: {
    display: 'block',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  currencyField: {
    width: '167px !important',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
       paddingLeft:'20px',
       paddingBlockStart: '20px',
       paddingRight: '20px'
     
    },
  },
  dailyCurrencyField: {
    width: '147px !important',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      paddingBottom: '20px !important'
    },
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '27px',
    color: '#182e3d',
    [theme.breakpoints.down('sm')]: {
      paddingLeft:'20px',
      
    },
  },
  w: {
    width: '100%',
    padding: theme.spacing(2),
    // [theme.breakpoints.up('sm')]: {
    //   width: '90%',
    //   margin: '0 auto',
    // },
    // [theme.breakpoints.up('md')]: {
    //   width: '75%',
    // },
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  }
}));
